export const compensationModelSelector = ({ EPPS: { loanInfo } }) =>
  loanInfo.compensation.model;

export const compensationValuesSelector = ({ epps: { lockSummary } }) => {
  const { comp, compVal } = lockSummary.selectedProduct;
  return { comp, compVal };
};
